module.exports = __webpack_public_path__ + "img/sebastien-voyer.d24f2374.png";